module.exports = __webpack_public_path__ + "media/เก่งเจ๋ง.e858662a.mp3";